// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"terms-hero_wrapper__eE7mV"};